
var sprite = require("/harness/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 31 31\" id=\"arrow-circle-right.7cec88bf\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <style type=\"text/css\"> #arrow-circle-right.7cec88bf .st0{fill:#51BFBB;} </style> <g> <path class=\"st0\" d=\"M15.5,31C7,31,0,24,0,15.5S7,0,15.5,0S31,7,31,15.5S24,31,15.5,31z M15.5,1C7.5,1,1,7.5,1,15.5S7.5,30,15.5,30\r\n\t\tS30,23.5,30,15.5S23.5,1,15.5,1z\"/> </g> <g> <path class=\"st0\" d=\"M12.8,22.9c-0.1,0-0.3,0-0.4-0.1c-0.2-0.2-0.2-0.5,0-0.7l6.6-6.6l-6.6-6.6c-0.2-0.2-0.2-0.5,0-0.7\r\n\t\ts0.5-0.2,0.7,0l6.6,6.6c0.2,0.2,0.3,0.4,0.3,0.6s-0.1,0.5-0.3,0.6l-6.6,6.6C13,22.9,12.9,22.9,12.8,22.9z\"/> </g> </symbol>";
module.exports = sprite.add(image, "arrow-circle-right.7cec88bf");


//////////////////
// WEBPACK FOOTER
// ./assets/icons/arrow-circle-right.svg
// module id = 1789
// module chunks = 0